module.exports = __webpack_public_path__ + "static/logo-musee-numerique-blanc.0f7123c9.svg";